<template>
    <div class="relative ml-auto mr-xl md:mr-2xl">
        <a :href="url">
            <span
                v-if="unreadCount > 0"
                class="badge is-floating"
            >
                {{ unreadCount }}
            </span>

            <font-awesome-icon
                icon="bell"
                class="text-sm text-gray-400"
                :class="{ 'text-gray-400': unreadCount === 0, 'text-gray-800': unreadCount > 0}"
            />
        </a>
    </div>

</template>

<script>
    export default {
        props: {
            url: {
                type: String,
                required: true,
            },
            initialUnreadCount: {
                type: Number,
                required: true,
            },
            bellColor: {
                type: String,
                required: false,
                default: 'text-gray-400',
            },
        },

        data() {
            return {
                unreadCount: this.initialUnreadCount,
            };
        },

        created() {
            const interval = setInterval(async () => {
                try {
                    const response = await axios.get(route('front.api.unread-notifications-count'));
                    this.unreadCount = response.data;
                } catch (error) {
                    clearInterval(interval);
                    console.error(error);
                    if (error.response?.status === 401) {
                        window.location.href = route('front.start');
                    }
                }
            }, 60000);
        },
    };
</script>
